import useBreadcrumbs from "use-react-router-breadcrumbs";
import { routes } from "../../../config/appRoutes";
import { NavLink } from "react-router-dom";
import { Breadcrumb, BreadcrumbItem } from "reactstrap";

const Breadcrumbs = () => {
	// https://www.npmjs.com/package/use-react-router-breadcrumbs
	// https://reacttraining.com/blog/react-router-v6-pre/
	const breadcrumbs = useBreadcrumbs(routes);
	return (
		<Breadcrumb>
			{breadcrumbs.map(({ match, breadcrumb }) => (
				<BreadcrumbItem key={match.pathname}>
					<NavLink to={match.pathname}>{breadcrumb}</NavLink>
				</BreadcrumbItem>
			))}
		</Breadcrumb>
	);
};

export default Breadcrumbs;
